const smtDrawerComponent = {
  bgColor: {
    default: 'white',
    _dark: 'gray.700'
  }
};

export default smtDrawerComponent;
